import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import { useGetFooterData, useGetHeaderData } from "@/api/api";

const NotFound = ({ children }) => {
  const { data: dataHeader } = useGetHeaderData();
  const { data: dataFooter } = useGetFooterData();
  return (
    <>
      <Header dataHeader={dataHeader} />
      {children}
      <Footer dataFooter={dataFooter} dataHeader={dataHeader} />
    </>
  );
};

export default NotFound;
